import * as React from 'react';
import './LongitudinalSlope.scss';

interface ILongitudinalSlopeProps {
    value: number;
}

const in_min = 0.001;
const in_max = 5;
const out_min = 3;
const out_max = 14;

const map = (value: number, in_min: number, in_max: number, out_min: number, out_max: number) => ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;

const LongitudinalSlope = (props: ILongitudinalSlopeProps) => {
    let _angle = map(props.value, in_min, in_max, out_min, out_max);

    return (
        <div className='LongitudinalSlope'>
            <div className='rectangle' style={{ transform: `rotate(${_angle}deg)` }}>
                <div className='icon'>
                    <div className='arrow'></div>
                </div>
            </div>
            <div className='lineY'></div>
            <div className='lineX'></div>
        </div>
    );
};

export default LongitudinalSlope;
